<div class="search-box-container" (clickOutside)="closeSearchBox()">
  <label class="searchbox" [class.dirty]="!!searchInput.value">
    <input
      #searchInput
      [placeholder]="'customSearch.placeholder' | cxTranslate"
      aria-label="search"
      (mousedown)="open(); this.placeholder = ''"
      (input)="search(searchInput.value)"
      (keydown.escape)="close($event)"
      (keydown.enter)="close($event, true); launchSearchResult($event, searchInput.value)"
      (keydown.arrowup)="focusPreviousChild($event)"
      (keydown.arrowdown)="focusNextChild($event)"
      [class.adjustedStylings]="adjustedTabletStylings"
    />

    <cx-icon
      [type]="iconTypes.CLOSE"
      aria-label="reset"
      (mousedown)="clear(searchInput)"
      (keydown.enter)="clear(searchInput)"
      class="reset"
      tabindex="0"
    ></cx-icon>

    <cx-icon
      [type]="iconTypes.SEARCH"
      aria-label="search"
      class="search"
      (focus)="open()"
      (mousedown)="avoidReopen($event)"
      (keydown.enter)="avoidReopen($event)"
      tabindex="0"
    ></cx-icon>
  </label>
  @if (results$ | async; as result) {
  <div class="results" (click)="close($event, true)">
    @if (result.message) {
    <div class="message" [innerHTML]="result.message"></div>
    }
    <div class="suggestions">
      @for (suggestion of result.suggestions; track suggestion) {
      <a
        [innerHTML]="suggestion | highlight : searchInput.value"
        [routerLink]=""
        (click)="close($event, true); checkKeywordRedirectUrl(suggestion, true); updateSearchInput(suggestion)"
        (keydown.arrowup)="focusPreviousChild($event)"
        (keydown.arrowdown)="focusNextChild($event)"
        (keydown.enter)="close($event, true); searchInput.value = suggestion"
        (keydown.escape)="close($event, true)"
        (blur)="close($event)"
      >
      </a>
      }
    </div>
    @if (result.products) {
    <div class="products" [class.less-than-four]="result.products.length < 4">
      @for (product of result.products; track product; let i = $index) {
      <div class="product">
        <a
          [routerLink]="
            {
              cxRoute: 'product',
              params: product
            } | cxUrl
          "
          [class.has-media]="config.displayProductImages"
          (keydown.arrowup)="focusPreviousChild($event)"
          (keydown.arrowdown)="focusNextChild($event)"
          (keydown.enter)="close($event, true)"
          (keydown.escape)="close($event, true)"
          (blur)="close($event)"
          (mousedown)="goToPdp(product, i, searchInput.value)"
        >
          <div class="product-image">
            @if (config.displayProductImages && product?.firstVariantImage) {
            <cx-media
              [container]="getImageRendition(product?.firstVariantImage)"
              [alt]="product.summary"
              [class.is-missing-fish]="businessType === 'fish'"
              removeImageTitleAttr
            ></cx-media>
            } @else {
            <cx-media
              class="cx-no-image is-missing"
              [class.is-missing-fish]="businessType === 'fish'"
              removeImageTitleAttr
            ></cx-media>
            }
          </div>
          <div class="product-details">
            <span class="code">{{ product.baseProduct }}</span>
            <h4 class="name" [innerHTML]="product.baseProductName"></h4>
            @if (showSrp) {
            <span class="price-label">{{ 'product.productList.srp' | cxTranslate }}</span>
            <span class="price">{{
              product.srpPrice?.formattedValue ? product.srpPrice?.formattedValue : '&nbsp;'
            }}</span>
            } @else { @if (!basepriceHidden) {
            <div>
              <span class="price-label">{{ 'product.productList.basePrice' | cxTranslate }}</span>
              <span class="price">{{
                product.basePrice?.formattedValue ? product.basePrice?.formattedValue : '&nbsp;'
              }}</span>
            </div>
            } }
          </div>
        </a>
      </div>
      }
    </div>
    }
  </div>
  }
</div>
